import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "p-fluid p-m-5" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = {
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = {
  for: "dataSourceLabel",
  class: "kn-material-input-label"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "p-d-flex p-flex-row" }
const _hoisted_15 = { class: "input-container" }
const _hoisted_16 = {
  for: "upload",
  class: "kn-material-input-label"
}
const _hoisted_17 = { class: "input-container p-d-flex p-flex-row" }
const _hoisted_18 = { class: "p-m-2" }
const _hoisted_19 = { class: "p-m-2" }
const _hoisted_20 = { class: "input-container" }
const _hoisted_21 = { class: "p-d-flex p-flex-row" }
const _hoisted_22 = {
  key: 0,
  class: "p-mr-2"
}
const _hoisted_23 = {
  for: "enable-metadata",
  class: "kn-material-input-label"
}
const _hoisted_24 = {
  for: "model-lock",
  class: "kn-material-input-label"
}
const _hoisted_25 = { class: "p-mt-2" }
const _hoisted_26 = {
  for: "smart-view",
  class: "kn-material-input-label"
}
const _hoisted_27 = {
  key: 0,
  class: "p-mt-5"
}
const _hoisted_28 = { class: "fa fa-info-circle" }
const _hoisted_29 = { class: "p-fluid p-m-5" }
const _hoisted_30 = { class: "p-field p-d-flex" }
const _hoisted_31 = { class: "kn-flex" }
const _hoisted_32 = { class: "p-float-label p-mr-2" }
const _hoisted_33 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_34 = { class: "kn-flex" }
const _hoisted_35 = { class: "p-float-label" }
const _hoisted_36 = {
  for: "label",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_Button = _resolveComponent("Button")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_GenerateDatamartCard = _resolveComponent("GenerateDatamartCard")
  const _component_MetawebSelectDialog = _resolveComponent("MetawebSelectDialog")
  const _component_Metaweb = _resolveComponent("Metaweb")
  const _component_KnOverlaySpinnerPanel = _resolveComponent("KnOverlaySpinnerPanel")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Card = _resolveComponent("Card")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.details')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.businessModel.name.$invalid && _ctx.v$.businessModel.name.$dirty
                            }],
              type: "text",
              modelValue: _ctx.v$.businessModel.name.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.businessModel.name.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "100",
              disabled: _ctx.businessModel.id,
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.businessModel.name.$touch())),
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFieldChange('name', $event.target.value))),
              "data-test": "name-input"
            }, null, 8, ["modelValue", "class", "disabled"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.businessModel.name,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('common.name')
                        }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "description",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.businessModel.description.$invalid && _ctx.v$.businessModel.description.$dirty
                            }],
              type: "text",
              modelValue: _ctx.v$.businessModel.description.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.businessModel.description.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "500",
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.businessModel.description.$touch())),
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFieldChange('description', $event.target.value))),
              disabled: _ctx.readonly,
              "data-test": "description-input"
            }, null, 8, ["modelValue", "class", "disabled"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.businessModelManager.description')), 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.businessModel.description,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.businessModelManager.description')
                        }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", null, [
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.category')) + " * ", 1),
            _createVNode(_component_Dropdown, {
              id: "category",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.businessModel.category.$invalid && _ctx.v$.businessModel.category.$dirty
                            }],
              modelValue: _ctx.v$.businessModel.category.$model,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.businessModel.category.$model = $event)),
              options: _ctx.categories,
              placeholder: _ctx.$t('common.category'),
              disabled: _ctx.readonly,
              onBeforeShow: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.businessModel.category.$touch())),
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onFieldChange('category', $event.value.VALUE_ID)))
            }, {
              value: _withCtx((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode("span", null, _toDisplayString(slotProps.value.VALUE_NM), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              option: _withCtx((slotProps) => [
                _createVNode("div", null, [
                  _createVNode("span", null, _toDisplayString(slotProps.option.VALUE_NM), 1)
                ])
              ]),
              _: 1
            }, 8, ["class", "modelValue", "options", "placeholder", "disabled"])
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.businessModel.category,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.businessModelManager.analyticalDriver')
                        }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("span", null, [
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.businessModelManager.dataSource')) + " * ", 1),
            _createVNode(_component_Dropdown, {
              id: "dataSourceLabel",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.businessModel.dataSourceLabel.$invalid && _ctx.v$.businessModel.dataSourceLabel.$dirty
                            }],
              modelValue: _ctx.v$.businessModel.dataSourceLabel.$model,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.businessModel.dataSourceLabel.$model = $event)),
              options: _ctx.datasources,
              placeholder: _ctx.$t('managers.businessModelManager.dataSourceLabelPlaceholder'),
              disabled: _ctx.readonly,
              onBeforeShow: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.businessModel.dataSourceLabel.$touch())),
              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onFieldChange('dataSourceLabel', $event.value)))
            }, {
              value: _withCtx((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("span", null, _toDisplayString(slotProps.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              option: _withCtx((slotProps) => [
                _createVNode("div", null, [
                  _createVNode("span", null, _toDisplayString(slotProps.option), 1)
                ])
              ]),
              _: 1
            }, 8, ["class", "modelValue", "options", "placeholder", "disabled"])
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.businessModel.dataSourceLabel,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.businessModelManager.dataSource')
                        }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_14, [
          _withDirectives(_createVNode("div", _hoisted_15, [
            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.businessModelManager.uploadFile')) + ":", 1),
            _createVNode(_component_KnInputFile, {
              changeFunction: _ctx.uploadFile,
              visibility: true
            }, null, 8, ["changeFunction"])
          ], 512), [
            [_vShow, !_ctx.metaWebVisible && !_ctx.readonly]
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _withDirectives(_createVNode(_component_Button, {
                class: "kn-button kn-button--primary",
                label: _ctx.$t('managers.businessModelManager.metaWeb'),
                onClick: _ctx.goToMetaWeb,
                "data-test": "metaweb-button"
              }, null, 8, ["label", "onClick"]), [
                [_vShow, _ctx.metaWebVisible]
              ])
            ]),
            _withDirectives(_createVNode("div", _hoisted_19, [
              _withDirectives(_createVNode(_component_Button, {
                class: "kn-button kn-button--primary",
                label: _ctx.$t('managers.businessModelManager.generate'),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.generateDatamartVisible = true)),
                "data-test": "generate-button"
              }, null, 8, ["label"]), [
                [_vShow, _ctx.metaWebVisible]
              ])
            ], 512), [
              [_vShow, _ctx.toGenerate]
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              (_ctx.selectedBusinessModel.id)
                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                    _createVNode(_component_InputSwitch, {
                      id: "enable-metadata",
                      class: "p-mr-2",
                      modelValue: _ctx.metaWebVisible,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.metaWebVisible = $event)),
                      disabled: _ctx.readonly,
                      "data-test": "metaweb-switch"
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.businessModelManager.enableMetaweb')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                _createVNode(_component_InputSwitch, {
                  id: "model-lock",
                  class: "p-mr-2",
                  modelValue: _ctx.businessModel.modelLocked,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.businessModel.modelLocked = $event)),
                  disabled: _ctx.readonly,
                  onChange: _ctx.onLockedChange
                }, null, 8, ["modelValue", "disabled", "onChange"]),
                _createVNode("label", _hoisted_24, _toDisplayString(_ctx.businessModel.modelLocked ? _ctx.$t('managers.businessModelManager.unlockModel') : _ctx.$t('managers.businessModelManager.lockModel')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode(_component_InputSwitch, {
                id: "smart-view",
                class: "p-mr-2",
                modelValue: _ctx.businessModel.smartView,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.businessModel.smartView = $event)),
                disabled: _ctx.readonly,
                onChange: _ctx.onSmartViewChange
              }, null, 8, ["modelValue", "disabled", "onChange"]),
              _withDirectives(_createVNode("label", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.businessModel.smartView ? _ctx.$t('managers.businessModelManager.smartView') : _ctx.$t('managers.businessModelManager.advancedView')), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  _ctx.$t('managers.businessModelManager.smartViewTooltip'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ])
          ])
        ]),
        (_ctx.metaWebVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
                start: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.configurationTablePrefixTitle')), 1)
                ]),
                end: _withCtx(() => [
                  _withDirectives(_createVNode("i", _hoisted_28, null, 512), [
                    [
                      _directive_tooltip,
                      _ctx.$t('managers.businessModelManager.prefixTooltip'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode("span", _hoisted_32, [
                      _withDirectives(_createVNode(_component_InputText, {
                        id: "tablePrefixLike",
                        class: ["kn-material-input", {
                                            'p-invalid': _ctx.v$.businessModel.tablePrefixLike.$invalid && _ctx.v$.businessModel.tablePrefixLike.$dirty
                                        }],
                        type: "text",
                        modelValue: _ctx.v$.businessModel.tablePrefixLike.$model,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.businessModel.tablePrefixLike.$model = $event)),
                        modelModifiers: { trim: true },
                        maxLength: "500",
                        disabled: _ctx.readonly,
                        onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.v$.businessModel.tablePrefixLike.$touch())),
                        onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onFieldChange('tablePrefixLike', $event.target.value))),
                        "data-test": "prefix-input"
                      }, null, 8, ["modelValue", "class", "disabled"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t('managers.businessModelManager.tablePrefixLikeExampleTooltip'),
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('managers.businessModelManager.tablePrefixLike')), 1)
                    ]),
                    _createVNode(_component_KnValidationMessages, {
                      vComp: _ctx.v$.businessModel.tablePrefixLike,
                      additionalTranslateParams: {
                                        fieldName: _ctx.$t('managers.businessModelManager.tablePrefixLike')
                                    }
                    }, null, 8, ["vComp", "additionalTranslateParams"])
                  ]),
                  _createVNode("div", _hoisted_34, [
                    _createVNode("span", _hoisted_35, [
                      _withDirectives(_createVNode(_component_InputText, {
                        id: "tablePrefixNotLike",
                        class: ["kn-material-input", {
                                            'p-invalid': _ctx.v$.businessModel.tablePrefixNotLike.$invalid && _ctx.v$.businessModel.tablePrefixNotLike.$dirty
                                        }],
                        type: "text",
                        modelValue: _ctx.v$.businessModel.tablePrefixNotLike.$model,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.v$.businessModel.tablePrefixNotLike.$model = $event)),
                        modelModifiers: { trim: true },
                        maxLength: "500",
                        disabled: _ctx.readonly,
                        onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.v$.businessModel.tablePrefixNotLike.$touch())),
                        onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onFieldChange('tablePrefixNotLike', $event.target.value))),
                        "data-test": "prefix-not-like-input"
                      }, null, 8, ["modelValue", "class", "disabled"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t('managers.businessModelManager.tablePrefixNotLikeExampleTooltip'),
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _createVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('managers.businessModelManager.tablePrefixNotLike')), 1)
                    ]),
                    _createVNode(_component_KnValidationMessages, {
                      vComp: _ctx.v$.businessModel.tablePrefixNotLike,
                      additionalTranslateParams: {
                                        fieldName: _ctx.$t('managers.businessModelManager.tablePrefixNotLike')
                                    }
                    }, null, 8, ["vComp", "additionalTranslateParams"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.generateDatamartVisible)
        ? (_openBlock(), _createBlock(_component_GenerateDatamartCard, {
            key: 0,
            businessModel: _ctx.selectedBusinessModel,
            user: _ctx.user,
            onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.generateDatamartVisible = false)),
            onGenerated: _ctx.onDatamartGenerated
          }, null, 8, ["businessModel", "user", "onGenerated"]))
        : _createCommentVNode("", true),
      _createVNode(_component_MetawebSelectDialog, {
        visible: _ctx.metawebSelectDialogVisible,
        selectedBusinessModel: _ctx.selectedBusinessModel,
        onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.metawebSelectDialogVisible = false)),
        onMetaSelected: _ctx.onMetaSelect
      }, null, 8, ["visible", "selectedBusinessModel", "onMetaSelected"]),
      _createVNode(_component_Metaweb, {
        visible: _ctx.metawebDialogVisible,
        propMeta: _ctx.meta,
        businessModel: _ctx.businessModel,
        onCloseMetaweb: _cache[25] || (_cache[25] = ($event: any) => (_ctx.metawebDialogVisible = false)),
        onModelGenerated: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$emit('modelGenerated')))
      }, null, 8, ["visible", "propMeta", "businessModel"]),
      _createVNode(_component_KnOverlaySpinnerPanel, {
        id: "metaweb-spinner",
        visibility: _ctx.loading
      }, null, 8, ["visibility"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.saveConfirmVisible,
        modal: true,
        closable: false
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.saveConfirmVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.ok')), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.saveRequired')) + " ", 1)
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}